<!-- eslint-disable vue/no-multiple-template-root -->
<template>
  <NuxtLoadingIndicator color="#AFE614" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
